"use client";

import { Disc, CircleDashed, Droplet, Car, Wrench, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const inspections = [{
  title: "Brake",
  icon: Disc
}, {
  title: "Tire",
  icon: CircleDashed
}, {
  title: "Oil Leak",
  icon: Droplet
}, {
  title: "General Vehicle",
  icon: Car
}, {
  title: "Tune-up",
  icon: Wrench
}];
export default function FreeInspections() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="freeinspections" className="bg-background">
      <div className="bg-zinc-950 py-20 lg:py-32 relative overflow-hidden">
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-full pointer-events-none" />
        
        <div className="container mx-auto px-4 md:px-6 relative z-10">
          <div ref={ref} className={`transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="text-center mb-16">
              <h2 className="text-5xl md:text-6xl lg:text-8xl font-bold text-primary font-default tracking-tighter uppercase drop-shadow-lg">
                Free Inspections
              </h2>
              <p className="text-zinc-400 mt-6 text-lg md:text-xl max-w-2xl mx-auto font-default">
                Keep your vehicle running safely with our complimentary diagnostic checks. No obligation, just peace of mind.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-6">
              {inspections.map((item, i) => {
              const Icon = item.icon;
              return <div key={i} data-index={i} className="bg-white/5 backdrop-blur-md border border-white/10 rounded p-8 flex flex-col items-center justify-center text-center relative group hover:bg-white/10 hover:border-white/20 transition-all duration-300 shadow-2xl">
                    <div className="absolute top-4 right-4 bg-green-500/20 rounded-full p-1">
                      <CircleCheck className="w-5 h-5 text-green-500" strokeWidth={2.5} />
                    </div>
                    
                    <div className="bg-white/10 p-5 rounded-full mb-6 group-hover:scale-110 group-hover:bg-primary/20 transition-all duration-300">
                      <Icon className="w-10 h-10 text-white group-hover:text-primary transition-colors" strokeWidth={1.5} />
                    </div>
                    
                    <h3 className="text-xl font-bold text-white font-default tracking-tight">
                      {item.title}
                    </h3>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}